<template>
  <div class="ma-auto background">
    <!-- <v-row dense class="pa-4" align="center">
      <v-col cols="12" md="4"> -->
    <!-- </v-col
      ><v-col cols="12" md="4">
        <div class="ma-2 text-h4 font-weight-bold text-center" style="color: #643a6b">
          家屬聯絡簿
        </div></v-col
      ></v-row
    > -->
    <v-card
      v-if="shuttleActive"
      rounded="lg"
      elevation="24"
      class="mx-auto my-6 px-2 py-8"
      color="#f2f2f2"
      width="90%"
    >
      <div class="text-h4 font-weight-bold text-center" style="color: #643a6b">交通車位置</div>
      <v-divider class="my-2" />
      <v-row no-gutters justify="center" align="center">
        <v-col cols="12">
          <l-map style="height: 500px" :zoom="zoom" :center="mapCenter">
            <l-tile-layer :url="tileLayerUrl" :attribution="tileLayerAttribution"></l-tile-layer>
            <!-- <l-marker
              v-for="(stop, index) in stops"
              :key="index"
              :lat-lng="stop.coordinates"
              :icon="stopIcon"
            >
              <l-popup>{{ stop.name }}</l-popup>
            </l-marker>
            <l-polyline
              :lat-lngs="actualRoute"
              color="blue"
              :weight="5"
              dash-array="15"
              line-cap="round"
              line-join="bevel"
            ></l-polyline> -->
            <l-marker :lat-lng="busPosition" :icon="busIcon">
              <l-popup>交通車位置</l-popup>
            </l-marker>
          </l-map>
        </v-col>
      </v-row>
    </v-card>

    <v-card rounded="lg" elevation="24" class="mx-auto my-6 px-2 py-8" color="#f2f2f2" width="90%">
      <div class="text-h4 font-weight-bold text-center mb-4" style="color: #643a6b">
        {{ elder_name }}的家庭聯絡簿
      </div>
      <v-row dense align="center" class="px-2 py-4">
        <v-btn tile large color="#BB2525" class="white--text" @click="changeDate(-1)" elevation="0">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn
          tile
          large
          color="#BB2525"
          class="white--text text-h5 text-sm-h6 font-weight-bold"
          @click="dateMenu = !dateMenu"
          elevation="0"
        >
          {{ selectedDate }}</v-btn
        >
        <v-menu ref="dateMenu" v-model="dateMenu" :close-on-content-click="false" bottom offset-y>
          <template v-slot:activator="{ on }">
            <div v-on="on"></div>
          </template>
          <v-date-picker v-model="selectedDate" @input="dateMenu = false"></v-date-picker>
        </v-menu>
        <v-btn tile large color="#BB2525" class="white--text" @click="changeDate(1)" elevation="0">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-row>
      <div class="text-h4 font-weight-bold text-center" style="color: #643a6b">健康資訊</div>
      <v-divider class="my-2" />
      <v-row dense class="pa-2">
        <v-col
          v-for="(item, index) in healthData"
          :key="index"
          cols="12"
          sm="6"
          md="3"
          class="pa-2"
        >
          <v-card class="pa-1" outlined color="#36BA98" rounded="xl">
            <v-card-title class="px-1 py-3 white--text">
              <v-icon class="mr-2 white--text">{{ item.icon }}</v-icon>
              {{ item.label }}
            </v-card-title>
            <v-card-text class="px-0 py-2 text-h5 font-weight-bold text-center white--text">
              {{ item.value !== null ? item.value : '--' }} {{ item.unit }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters justify="center" align="center" class="my-4">
        <v-col class="d-flex justify-center pa-2" cols="12" lg="6">
          <ChartHeartRate :data="weeklyData.dataHeartRate" :label="weeklyData.labelDate" />
        </v-col>
        <v-col class="d-flex justify-center pa-2" cols="12" lg="6">
          <ChartBP
            :dataShrink="weeklyData.dataShrink"
            :dataRelax="weeklyData.dataRelax"
            :label="weeklyData.labelDate"
          />
        </v-col>
        <v-col class="d-flex justify-center pa-2" cols="12" lg="6">
          <ChartTemperature
            :dataTemperature="weeklyData.dataTemperature"
            :dataBreathe="weeklyData.dataBreathe"
            :label="weeklyData.labelDate"
          />
        </v-col>
        <v-col class="d-flex justify-center pa-2" cols="12" lg="6">
          <ChartBloodSugar
            :dataBloodSugar="weeklyData.dataBloodSugar"
            :label="weeklyData.labelDate"
          />
        </v-col>
        <v-col class="d-flex justify-center pa-2" cols="12" lg="6">
          <ChartSpO2 :dataSpO2="weeklyData.dataSpO2" :label="weeklyData.labelDate" />
        </v-col>
        <v-col class="d-flex justify-center pa-2" cols="12" lg="6">
          <ChartWeight :dataWeight="weeklyData.dataWeight" :label="weeklyData.labelDate" />
        </v-col>
      </v-row>
      <!-- </v-card> -->

      <!-- <v-card elevation="0" class="mx-auto pa-2" color="#f2f2f2" width="90%"> -->
      <div class="text-h4 font-weight-bold text-center" style="color: #643a6b">日誌紀錄</div>
      <v-divider class="my-2" />
      <v-card-text class="text-center mb-4">
        <div
          v-if="Array.isArray(contents) && contents.length === 0"
          class="text-h5 font-weight-bold"
        >
          本日無填寫紀錄
        </div>
        <v-container v-else>
          <v-row>
            <v-col v-for="(item, key) in filteredContents" :key="key" cols="6" sm="4" md="3">
              <div class="text-h6 font-weight-bold black--text">
                {{ item.question }}
              </div>
              <div>
                {{ item.answer }}
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card rounded="lg" elevation="24" class="mx-auto my-6 px-2 py-8" color="#f2f2f2" width="90%">
      <div class="text-h4 font-weight-bold text-center" style="color: #643a6b">留言板</div>
      <v-divider class="my-2" />

      <!-- 顯示留言 -->
      <div ref="messageList" class="message-list">
        <v-row v-for="(message, index) in messages" :key="index" class="my-2">
          <!-- 機構員工的留言，顯示在左側 -->
          <v-col v-if="message.commenter === 'employee'" cols="12" class="text-left">
            <v-card class="pa-2 staff-message" color="#e3f2fd">
              <div class="font-weight-bold">機構員工：</div>
              <div>{{ message.comment }}</div>
              <small class="timestamp text-right">
                {{ formatDate(message.created) }}
                {{ formatTime(message.created) }}
                <small v-if="message.confirm" style="text-align: right">已讀</small>
              </small>
            </v-card>
          </v-col>

          <!-- 家屬的留言，顯示在右側 -->
          <v-col v-else-if="message.commenter === 'family'" cols="12" class="text-right">
            <v-card class="pa-2 family-message" color="#ffebee">
              <div class="font-weight-bold">家屬：</div>
              <div>{{ message.comment }}</div>
              <div class="timestamp text-left">
                {{ formatDate(message.created) }}
                {{ formatTime(message.created) }}
                <small v-if="message.confirm" style="text-align: right">已讀</small>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <v-divider class="my-2" />

      <!-- 輸入留言 -->
      <v-textarea
        v-model="newMessage"
        label="請輸入留言..."
        auto-grow
        outlined
        color="#643a6b"
      ></v-textarea>

      <!-- 提交按鈕 -->
      <v-btn color="#643a6b" dark @click="submitMessage"> 提交留言 </v-btn>
    </v-card>

    <v-card v-show="false" elevation="0" class="mx-auto my-2 pa-2" color="#f2f2f2" width="90%">
      <!-- <v-row dense> -->
      <div class="text-h4 font-weight-bold text-center" style="color: #643a6b">預約探視與請假</div>
      <!-- <v-btn class="mx-4 white--text" color="#313866" @click="handleDialog">
          <v-icon>mdi-calendar-plus</v-icon>
          新增
        </v-btn> -->
      <!-- </v-row> -->
      <v-divider class="my-2" />
      <v-row dense>
        <v-col v-for="event in events" :key="event.id" cols="12" sm="6" md="4" lg="3">
          <v-card class="pa-1" :disabled="event.past" :color="event.past ? '#b6b6b6' : ''">
            <v-row dense justify="center">
              <v-col cols="4" class="text-center">
                <div class="text-subtitle-1 font-weight-bold">
                  {{ formatDate(event.start) }}
                </div>
                <div>{{ formatTime(event.start) }}</div>
                <div>-</div>
                <div>{{ formatTime(event.end) }}</div>
              </v-col>
              <v-col cols="8" class="px-4 align-self-center">
                <div class="text-h6 font-weight-bold">
                  {{ event.description }}
                </div>
                <div class="text-caption font-weight-bold">
                  <v-chip
                    class="white--text"
                    :color="
                      event.event_type === '隔離'
                        ? '#0E21A0'
                        : event.event_type === '探視'
                        ? '#4D2DB7'
                        : event.event_type === '請假'
                        ? '#9D44C0'
                        : '#EC53B0'
                    "
                    x-small
                  >
                    {{ event.event_type }}
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="dialog" width="500">
      <v-card class="pa-2">
        <v-card-text class="pa-2">
          <v-row dense>
            <v-col cols="12" class="pa-2">
              <v-select
                outlined
                dense
                :items="eventTypes"
                label="事件類型"
                hide-details=""
                v-model="event_type"
              ></v-select></v-col
            ><v-col cols="12" class="pa-2">
              <v-text-field
                outlined
                dense
                label="事由"
                hide-details=""
                v-model="description"
              ></v-text-field> </v-col
            ><v-col cols="12" class="pa-2">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    dense
                    v-model="date"
                    label="選擇日期"
                    hide-details=""
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" @input="menu = false"></v-date-picker>
              </v-menu> </v-col
            ><v-col cols="12" class="pa-2">
              <v-select
                outlined
                dense
                :items="timeOptions"
                label="選擇時間"
                hide-details=""
                v-model="time"
              ></v-select
            ></v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-2 justify-center">
          <v-btn color="blue" class="white--text" @click="addEvents">送出</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import moment from 'moment'
import ChartBloodSugar from '@/components/ChartBloodSugar.vue'
import ChartBP from '@/components/ChartBP.vue'
import ChartHeartRate from '@/components/ChartHeartRate.vue'
import ChartSpO2 from '@/components/ChartSpO2.vue'
import ChartTemperature from '@/components/ChartTemperature.vue'
import ChartWeight from '@/components/ChartWeight.vue'
import { LMap, LTileLayer, LMarker, LPolyline, LPopup } from 'vue2-leaflet'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

export default {
  components: {
    ChartBloodSugar,
    ChartBP,
    ChartHeartRate,
    ChartSpO2,
    ChartTemperature,
    ChartWeight,
    LMap,
    LTileLayer,
    LMarker,
    LPolyline,
    LPopup,
  },
  data() {
    return {
      id: '',
      name: '',
      weeklyData: {
        dataBloodSugar: [],
        dataShrink: [],
        dataRelax: [],
        dataHeartRate: [],
        dataSpO2: [],
        dataTemperature: [],
        dataBreathe: [],
        dataWeight: [],
        labelDate: [],
      },
      events: [],
      contents: {},
      dialog: false,
      eventTypes: ['送醫', '請假', '探視', '隔離'],
      event_type: null,
      description: '',
      date: new Date().toLocaleDateString().replaceAll('/', '-'),
      menu: false,
      timeOptions: this.generateTimeOptions(),
      time: null,
      messages: [],
      newMessage: '',
      zoom: 16,
      mapCenter: [25.068244177284676, 121.49636747447765], // 地圖中心點
      tileLayerUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      tileLayerAttribution:
        "&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors",
      stops: [
        { name: 'A', coordinates: [25.068892509426888, 121.49070162649532] },
        { name: 'B', coordinates: [25.068365068226072, 121.49637811369674] },
        { name: 'C', coordinates: [25.07, 121.5] },
      ],
      stopIcon: L.icon({
        iconUrl: require('@/assets/bus-stop.png'),
        iconSize: [50, 50],
      }),
      busPosition: [23, 121],
      busIcon: L.icon({
        iconUrl: require('@/assets/bus.png'),
        iconSize: [60, 60],
      }),
      actualRoute: [],
      dailyVitalSign: null,
      selectedDate: moment().format('YYYY-MM-DD'),
      dateMenu: false,
      shuttleActive: false,
      elder_name: '',
    }
  },
  methods: {
    async getWeeklyVitalSign() {
      this.weeklyData = {
        dataBloodSugar: [],
        dataShrink: [],
        dataRelax: [],
        dataHeartRate: [],
        dataSpO2: [],
        dataTemperature: [],
        dataBreathe: [],
        dataWeight: [],
        labelDate: [],
      }
      try {
        const res = await axios.get(`/api/attendance/contacts/vitalsign/${this.id}/`, {
          params: { datetime: `${moment(this.selectedDate).format('YYYY-MM-DDTHH:mm:ssZ')}` },
        })
        if (res.data.vital_sign.length > 0) {
          res.data.vital_sign.forEach((element) => {
            let datetime = element.start
            datetime = moment(datetime).local().format('MM/DD')
            this.weeklyData.labelDate.push(datetime)
            this.weeklyData.dataBloodSugar.push(element.blood_sugar)
            this.weeklyData.dataShrink.push(element.shrink)
            this.weeklyData.dataRelax.push(element.relax)
            this.weeklyData.dataHeartRate.push(element.hr)
            this.weeklyData.dataSpO2.push(element.SPO2)
            this.weeklyData.dataTemperature.push(element.temperature)
            this.weeklyData.dataBreathe.push(element.breathe)
            this.weeklyData.dataWeight.push(element.weight)
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getEvents() {
      try {
        const res = await axios.get(`/api/attendance/contacts/event/${this.id}/`, {
          params: { datetime: `${moment(this.selectedDate).format('YYYY-MM-DDTHH:mm:ssZ')}` },
        })
        if (res.data.event.length > 0) {
          this.events = res.data.event
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getComments() {
      try {
        const res = await axios.get(`/api/attendance/contacts/comment/${this.id}/`, {
          params: { datetime: `${moment(this.selectedDate).format('YYYY-MM-DDTHH:mm:ssZ')}` },
        })
        if (res.data.comment.length > 0) {
          this.messages = res.data.comment
        }
      } catch (error) {
        console.log(error)
      }
    },
    async fetchHealthData() {
      try {
        const res = await axios.get(`/api/attendance/contacts/current/${this.id}/`, {
          params: { datetime: `${moment(this.selectedDate).format('YYYY-MM-DDTHH:mm:ssZ')}` },
        })
        if (res.data.status === 'success') {
          this.dailyVitalSign = res.data.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getRecord() {
      try {
        const res = await axios.get(`/api/journal/search_record`, {
          params: { case_num: this.id, date: this.selectedDate },
        })
        if (res.data.status === 'success') {
          this.contents = res.data.data
          console.log(this.contents)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getShuttle() {
      const datetime = moment().format()
      try {
        const res = await axios.get(`/api/traffic/contacts/shuttle/info/${this.id}/`, {
          params: { datetime: `${datetime}` },
        })
        if (res.data.data.length > 0) {
          this.busPosition = res.data.data
          this.mapCenter = res.data.data
          this.shuttleActive = true
        }
      } catch (error) {
        console.log(error)
      }
    },
    changeDate(days) {
      this.selectedDate = moment(this.selectedDate).add(days, 'days').format('YYYY-MM-DD')
    },
    async addEvents() {
      let start = moment(this.date + ' ' + this.time, 'YYYY-M-DD HH:mm').toDate()
      let end = moment(start).add(1, 'hours').toDate()
      let formattedStart = moment(start).format()
      let formattedEnd = moment(end).format()
      const encodedStart = encodeURIComponent(formattedStart)
      const encodedEnd = encodeURIComponent(formattedEnd)

      let data = qs.stringify({
        event_type: this.event_type,
        description: this.description,
        start: formattedStart,
        end: formattedEnd,
      })
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `/api/attendance/events/${this.id}/`,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: data,
      }
      try {
        let res = await axios.request(config)
        console.log(res.data)
        this.getEvents()
        this.dialog = false
      } catch (error) {
        console.log(error)
      }
    },
    async submitMessage() {
      let data = qs.stringify({
        comment: this.newMessage,
      })
      try {
        let res = await axios.post(`/api/attendance/comment/${this.id}/`, data)
      } catch (error) {
        console.log(error)
      }
      this.getComments()
      this.newMessage = ''
    },
    handleDialog() {
      this.event_type = ''
      this.description = ''
      this.date = new Date().toLocaleDateString().replaceAll('/', '-')
      this.time = ''
      this.dialog = true
    },
    generateTimeOptions() {
      const options = []
      for (let i = 8; i <= 18; i++) {
        const time = i < 10 ? `0${i}:00` : `${i}:00`
        options.push(time)
      }
      return options
    },
    formatDate(dateTimeStr) {
      const date = new Date(dateTimeStr)
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${month}/${day}`
    },
    formatTime(dateTimeStr) {
      const date = new Date(dateTimeStr)
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    async fetchRoute() {
      const apiKey = '5b3ce3597851110001cf6248332ed748e38e4b2fa3f9a3ee4c985584' // OpenRouteService API key
      const coordinates = this.stops.map((stop) => [stop.coordinates[1], stop.coordinates[0]]) // 轉換成(經度,緯度)

      try {
        const response = await axios.post(
          'https://api.openrouteservice.org/v2/directions/driving-car',
          { coordinates },
          {
            headers: {
              Authorization: apiKey,
              'Content-Type': 'application/json',
            },
          }
        )

        const data = response.data

        if (data && data.routes && data.routes.length > 0) {
          const geometry = data.routes[0].geometry
          this.actualRoute = this.decodePolyline(geometry)
        }
      } catch (error) {
        console.error('Error fetching route:', error)
      }
    },
    decodePolyline(encoded) {
      let points = []
      let index = 0,
        lat = 0,
        lng = 0

      while (index < encoded.length) {
        let b,
          shift = 0,
          result = 0
        do {
          b = encoded.charCodeAt(index++) - 63
          result |= (b & 0x1f) << shift
          shift += 5
        } while (b >= 0x20)
        const dlat = result & 1 ? ~(result >> 1) : result >> 1
        lat += dlat

        shift = 0
        result = 0
        do {
          b = encoded.charCodeAt(index++) - 63
          result |= (b & 0x1f) << shift
          shift += 5
        } while (b >= 0x20)
        const dlng = result & 1 ? ~(result >> 1) : result >> 1
        lng += dlng

        points.push([lat / 1e5, lng / 1e5])
      }
      return points
    },
    scrollToBottom() {
      const container = this.$refs.messageList
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },
  },
  computed: {
    healthData() {
      if (!this.dailyVitalSign) return []
      return [
        { label: '心率', value: this.dailyVitalSign.hr, unit: 'bpm', icon: 'mdi-heart-pulse' },
        {
          label: '體溫',
          value: this.dailyVitalSign.temperature,
          unit: '°C',
          icon: 'mdi-thermometer',
        },
        {
          label: '呼吸',
          value: this.dailyVitalSign.breathe,
          unit: '次/分鐘',
          icon: 'mdi-weather-windy',
        },
        {
          label: '血壓',
          value:
            this.dailyVitalSign.shrink !== null && this.dailyVitalSign.relax !== null
              ? `${this.dailyVitalSign.shrink}/${this.dailyVitalSign.relax}`
              : null,
          unit: 'mmHg',
          icon: 'mdi-blood-bag',
        },
        { label: '血氧', value: this.dailyVitalSign.SPO2, unit: '%', icon: 'mdi-mother-heart' },
        {
          label: '血糖',
          value: this.dailyVitalSign.blood_sugar,
          unit: 'mg/dL',
          icon: 'mdi-flask-outline',
        },
        {
          label: '體重',
          value: this.dailyVitalSign.weight,
          unit: 'kg',
          icon: 'mdi-weight-kilogram',
        },
      ]
    },
    filteredContents() {
      const entries = Object.entries(this.contents)
      return Object.fromEntries(entries.slice(0, -2))
    },
  },
  mounted() {
    this.fetchHealthData()
    this.getWeeklyVitalSign()
    this.getEvents()
    this.getComments()
    this.getRecord()
    this.getShuttle()
    // this.fetchRoute()
  },
  created() {
    this.id = localStorage.getItem('id')
    this.elder_name = localStorage.getItem('elder_name') || ''
  },
  watch: {
    selectedDate() {
      this.fetchHealthData()
      this.getWeeklyVitalSign()
      this.getEvents()
      this.getRecord()
    },
    messages: {
      handler() {
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
.background {
  background-color: #f2f2f2;
}
.message-list {
  max-height: 600px;
  overflow-y: auto; /* 如果留言過多，添加滾動條 */
  max-width: 100%;
  padding-left: 1.5em;
  padding-right: 1.5em;
  font-size: 1.5em;
}

/* 機構員工的留言樣式 */
.staff-message {
  max-width: 60%;
  margin-left: 1;
  float: left;
}

/* 家屬的留言樣式 */
.family-message {
  max-width: 60%;
  margin-right: 1;
  float: right; /* 讓家屬的留言靠右對齊 */
}

/* 時間戳 */
.timestamp {
  font-size: 12px;
  color: #888; /* 灰色淺字 */
  margin-top: 5px;
}

/* Leaflet */
.leaflet-container {
  width: 100%;
  height: 100%;
  z-index: 0;
}

.leaflet-marker-icon {
  background-size: contain;
  background-repeat: no-repeat;
}

.leaflet-marker-shadow {
  display: none;
}
</style>
